import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import Modal from "../../../components/ui/modal";

const formatCurrency = (n) => `TZS ${Number(n).toLocaleString()}`;

const ViewSaasPaymentModal = ({ payment, onClose }) => {
  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      title="Payment Details"
      footer={
        <div className="flex justify-end">
          <Button variant="outline" onClick={onClose}>Close</Button>
        </div>
      }
    >
      <div className="space-y-2">
        <div className="flex justify-between"><span className="font-semibold">Reference:</span><span>{payment?.ref}</span></div>
        <div className="flex justify-between"><span className="font-semibold">Plan:</span><span>{payment?.plan_type}</span></div>
        <div className="flex justify-between"><span className="font-semibold">Owner:</span><span>{payment?.business_owner}</span></div>
        <div className="flex justify-between"><span className="font-semibold">Amount:</span><span className="font-bold text-blue-600">{formatCurrency(payment?.amount)}</span></div>
        <div className="flex justify-between"><span className="font-semibold">Payment Date:</span><span>{payment?.payment_date}</span></div>
        <div className="flex justify-between"><span className="font-semibold">Method:</span><span>{payment?.method}</span></div>
        <div className="flex justify-between"><span className="font-semibold">Status:</span><Badge variant="outline" className={payment?.status === "PAID" ? "bg-green-50 text-green-700 border-green-200" : "bg-yellow-50 text-yellow-700 border-yellow-200"}>{payment?.status}</Badge></div>
        <div className="flex justify-between"><span className="font-semibold">Expire Date:</span><span>{payment?.expire_date}</span></div>
        <div className="flex justify-between"><span className="font-semibold">Days Remaining:</span><span>{payment?.days_remaining} days</span></div>
      </div>
    </Modal>
  );
};

export default ViewSaasPaymentModal;